"use client";

import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import type { ReactElement, ReactNode } from "react";

type StatItemProps = {
  tooltipTitle: string;
  icon: ReactElement;
  value: ReactNode;
  comparison?: number | null;
  positiveIfHigher?: boolean;
};

export default function AnalyticsPageStatItem({ tooltipTitle, icon, value, comparison, positiveIfHigher = true }: StatItemProps) {
  const color = typeof comparison === "number"
    ? (positiveIfHigher ? (comparison > 0 ? "success.main" : "error.main") : (comparison < 0 ? "success.main" : "error.main"))
    : undefined;

  return (
    <Tooltip title={tooltipTitle}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.25, cursor: "default" }}>
        <Box sx={{ '& svg': { fontSize: '1rem', color: 'text.secondary' } }}>{icon}</Box>

        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            width: "45px"
          }}>
          {value}
          {typeof comparison === "number" && (
            <Typography component="span" variant="caption" sx={{ color, ml: 0.5 }}>
              {comparison > 0 ? `+${comparison}%` : `${comparison}%`}
            </Typography>
          )}
        </Typography>
      </Box>
    </Tooltip>
  );
}
